<i18n src="@/locales/components/CbsDynamicFormConfig.json"></i18n>

<template>
	<div class="relation-field-config">
		<div>
			<legend>Trường liên quan<span class="text-danger">&nbsp;*</span>:</legend>
			<v-select
				label="name"
				name="relation"
				ref="relationSelectRef"
				v-validate="'required'"
				v-model="localRelatedValue"
				:options="fieldOptions"
				:reduce="option => option.id"
				:data-vv-as="$t('FieldConfig.RelationModel')"
				:placeholder="`${$t('Actions.Choose')} ${$t('FieldConfig.RelationModel').toLowerCase()}`"
			>
				<span slot="no-options">{{ $t("Notify.NoMatchingOptions") }}</span>
			</v-select>
			<span class="text-danger text-sm">{{ errors.first("relation") }}</span>
		</div>
		
		<div class="my-5">
			<legend>Tên cột tham chiếu<span class="text-danger">&nbsp;*</span>:</legend>
			<cbs-input
				class="w-full"
				type="text"
				name="text-length"
				v-model="localValue"
				:data-vv-as="$t('FieldConfig.TextLength')"
				:placeholder="`${$t('Actions.Input')} tên cột`"
			/>
			<span class="text-danger text-sm">{{ errors.first("text-length") }}</span>
		</div>
	</div>
</template>

<script>
import vSelect from "vue-select";
import requestV2GQL from "@/http/requests/request/request_v2_gql.js";

export default {
	inheritAttrs: false,
	inject: ["parentValidator"],
	name: "AutofillFieldConfig",
	components: { vSelect },
	props: {
		value: {
			type: Object,
			required: true,
			// validator: prop => prop.hasOwnProperty("form_id") && prop.hasOwnProperty("column")
		},
		fieldOptions: {
			type: Array
		}
	},
	data() {
		return {
			relationModels: []
		};
	},
	computed: {
		localValue: {
			get() {
				return this.value.column;
			},
			set(val) {
				this.$emit("input", { ...this.value, column: val });
			}
		},
		localRelatedValue: {
			get() {
				return this.value.form_id;
			},
			set(val) {
				this.$emit("input", { ...this.value, form_id: val });
			}
		},
	},
	methods: {
		async getRelations() {
			let refLoading = this.$refs.relationSelectRef && this.$refs.relationSelectRef.toggleLoading;
			try {
				if (refLoading) {
					refLoading(true);
				}

				let generalData = await requestV2GQL.getGeneral();
				generalData = JSON.parse(generalData);
				if (generalData) {
					this.relationModels = generalData.map_relations || [];
				}
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				if (refLoading) {
					refLoading(false);
				}
			}
		}
	},
	mounted() {
		// this.getRelations();
	},
	created() {
		if (this.parentValidator) {
			this.$validator = this.parentValidator;
		}
	}
};
</script>
